var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.649 7.55507C16.649 7.76652 16.5789 7.97798 16.4385 8.11895L8.01746 16.5066C7.80694 16.7181 7.38588 16.7181 7.17536 16.5066L1.49115 10.7269C1.28062 10.5154 1.28062 10.0925 1.49115 9.88106L9.9122 1.56388C10.0525 1.42291 10.1929 1.35242 10.4034 1.35242L15.9473 1.70485C16.1578 1.70485 16.3683 1.9163 16.3683 2.12776L16.649 7.55507ZM12.4385 3.81939C11.5262 3.81939 10.7543 4.59472 10.7543 5.51102C10.7543 6.42731 11.5262 7.20265 12.4385 7.20265C13.3508 7.20265 14.1227 6.42731 14.1227 5.51102C14.1227 4.59472 13.3508 3.81939 12.4385 3.81939Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.9fa39b6c7bc41c6629032c65b834c072.svg";
export { ForwardRef as ReactComponent };